export default __webpack_public_path__ + "static/media/programming-icon.46d1be2b.svg";